import React from 'react';
import { Header } from '../components/Header';
import { ProgressIndicator } from '../components/ProgressIndicator';
import { motion } from 'framer-motion';
interface StartScreenProps {
  onNext: () => void;
}
export function StartScreen({
  onNext
}: StartScreenProps) {
  return <div className="h-full flex flex-col overflow-hidden" data-id="element-235">
      <div className="flex-none" data-id="element-236">
        <Header title="Start Your Move-Out" showLogo data-id="element-237" />
      </div>

      <div className="flex-1 flex flex-col px-6 overflow-y-auto" data-id="element-238">
        <p className="text-center text-sm text-gray-600 mb-4 flex-none leading-relaxed" data-id="element-239">
          Follow 3 Steps For Just 5 Minutes To
          <br data-id="element-240" />
          Complete Your Move-Out .
        </p>

        <div className="flex-none" data-id="element-241">
          <ProgressIndicator currentStep={0} data-id="element-242" />
        </div>

        {/* Illustration */}
        <div className="flex-1 flex items-center justify-center py-4 min-h-0" data-id="element-243">
          <img src="https://cdn.magicpatterns.com/uploads/uVPxgmbj1cZe3B5rdvH7UF/photo.png" alt="Person walking with bag looking at phone" className="w-full max-w-[300px] h-auto object-contain max-h-full" data-id="element-244" />
        </div>
      </div>

      {/* Footer Button */}
      <div className="flex-none px-6 pt-2 pb-8 bg-transparent" data-id="element-245">
        <motion.button whileTap={{
        scale: 0.97
      }} onClick={onNext} className="w-full bg-[#0F4C3A] text-white py-4 rounded-xl font-semibold text-lg hover:bg-[#134E3A] transition-colors shadow-md" data-id="element-246">
          Let's start
        </motion.button>
      </div>
    </div>;
}